<template>
  <div>
    <list-widget :items="products.items" routeName="product" :hideHeader="true" :changeRoute="true" :addNewRouteName="isLandlord() ? 'add-product' : 'false'" :addNewTitle="$t('add_product.new_product')" :mobRouteName="{ onListItemClick: 'product' }" :isWebsocketConnect="true"></list-widget>
    <div class="list-widget__footer items-container__footer" v-if="products.items">
      <slot name="footer"><a class="link" v-on:click.stop.prevent="extendLimit()" v-if="products.total > products.items.length">{{ $t('common.load_more') }}</a></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as mTypes from 'store/mutation-types';
import ListWidget from 'common/ListWidget';

export default {
  components: {
    ListWidget,
  },
  computed: mapGetters({
    products: 'landlord/products/products',
    productsLimit: 'landlord/products/limit',
    productsKeywordFilter: 'landlord/products/keywordFilter',
    user: 'user/user/user',
  }),
  watch: {
    productsLimit() {
      this.loadProducts();
    }
  },
  created() {
    this.$store.commit(`landlord/products/${mTypes.SET_LIMIT}`, 10);
    this.loadProducts();
  },
  methods: {
    loadProducts() {
      if (this.isLandlord()) {
        this.fetchProducts();
      } else {
        this.fetchCompanyProducts();
      }
    },
    fetchProducts() {
      this.$store.dispatch('landlord/products/fetch', { keyword: this.$route.query.keyword, user: this.user });
    },
    fetchCompanyProducts() {
      this.$store.dispatch('landlord/products/fetchTenantProducts', { user: this.user });
    },
    extendLimit() {
      this.$store.commit(`landlord/products/${mTypes.SET_LIMIT}`, this.productsLimit + 10);
    },
  },
  data() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/products/Sidebar.vue